exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card{margin-top:16px;margin-bottom:16px}.modal-dialog-person-form{min-width:100%;max-width:100px;margin:0}.modal-content-person-form{min-height:600px;max-height:1000px;font-size:17px}.personal-form-btn{font-size:2rem}", ""]);

// exports
